import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Dict } from "../types";
import { Injectable } from "@angular/core";
import { UserHttpService } from "../generated/user-http.service";
import { UserItem } from "../generated/types";


@Injectable()
export class UserOptionsResolver implements Resolve<Dict<UserItem>> {

  constructor(private userHttpService: UserHttpService) {

  }

  async resolve(route: ActivatedRouteSnapshot) {

    const items = await this.userHttpService.getItems('').toPromise();

    const result: any = {};

    for (let item of items) {
      result[item.id] = item;
    }

    return result;
  }

}
